import generateLocalStorageKey from '../../pages/denali/Analysis/QueryBlueprints/components/presentationManagement/generateLocalStorageKey'
import DummyRenderer from './renderers/DummyRenderer'
import RedtailMetricRenderer from './renderers/redtailMetric'
import RedtailMetricConfigEditor from './renderers/redtailMetric/ConfigEditor'
import RedtailListRenderer from './renderers/redtailList'
import RedtailListConfigEditor from './renderers/redtailList/ConfigEditor'
import SyncedTransactionsRenderer from './renderers/syncedTransactions'
import SyncedTransactionsConfigEditor from './renderers/syncedTransactions/ConfigEditor'
import { DEFAULT_CONFIG } from './renderers/syncedTransactions/constants'
import WoSfTaskListRenderer from './renderers/woSfTaskList'
import WoSfTaskListConfigEditor from './renderers/woSfTaskList/ConfigEditor'
import ActivitySummaryRenderer from './renderers/activitySummary'
import ActivitySummaryConfigEditor from './renderers/activitySummary/ConfigEditor'
import { DEFAULT_CONFIG as ACTIVITY_SUMMARY_DEFAULT_CONFIG } from './renderers/activitySummary/constants'

export const componentTypeRegistry = {
  dummy: {
    domain: 'system',
    domainDisplayName: 'System',
    displayName: 'Dummy',
    renderer: DummyRenderer
  },
  'redtail-metric': {
    domain: 'redtail',
    domainDisplayName: 'Redtail',
    displayName: 'Metric',
    renderer: RedtailMetricRenderer,
    configEditor: RedtailMetricConfigEditor,
    styleVariants: [
      { label: 'Default (Medium)', value: 'default' },
      { label: 'Small', value: 'sm' },
      { label: 'Medium', value: 'md' },
      { label: 'Large', value: 'lg' }
    ]
  },
  'redtail-list': {
    domain: 'redtail',
    domainDisplayName: 'Redtail',
    displayName: 'List',
    renderer: RedtailListRenderer,
    configEditor: RedtailListConfigEditor
  },
  'synced-transactions': {
    domain: 'portfolio',
    domainDisplayName: 'Portfolio',
    displayName: 'Synced Transactions',
    renderer: SyncedTransactionsRenderer,
    configEditor: SyncedTransactionsConfigEditor,
    styleVariants: [
      { label: 'Default', value: 'default' },
      { label: 'Flat', value: 'flat' },
      { label: 'Glass', value: 'glass' }
    ],
    defaultConfig: () => ({
      ...DEFAULT_CONFIG,
      localStorageKey: generateLocalStorageKey()
    })
  },
  'wo-sf-task-list': {
    domain: 'salesforce',
    domainDisplayName: 'Salesforce',
    displayName: 'Client Task List',
    renderer: WoSfTaskListRenderer,
    configEditor: WoSfTaskListConfigEditor,
    styleVariants: [
      { label: 'Small', value: 'sm' },
      { label: 'Medium (Default)', value: 'md' },
      { label: 'Large', value: 'lg' }
    ],
    defaultConfig: {
      title: 'Action Items',
      defaultStatusFilter: 'open',
      showDebugControl: true
    }
  },
  'activity-summary': {
    domain: 'portfolio',
    domainDisplayName: 'Portfolio',
    displayName: 'Activity Summary',
    renderer: ActivitySummaryRenderer,
    configEditor: ActivitySummaryConfigEditor,
    defaultConfig: () => ({
      ...ACTIVITY_SUMMARY_DEFAULT_CONFIG,
      localStorageKey: generateLocalStorageKey()
    })
  }
}

export const getTypesByDomain = () => {
  const grouped = {}
  Object.entries(componentTypeRegistry).forEach(([code, entry]) => {
    if (!grouped[entry.domain]) {
      grouped[entry.domain] = []
    }
    grouped[entry.domain].push({ code, ...entry })
  })
  return grouped
}

export const getDomains = () => {
  const seen = new Map()
  Object.values(componentTypeRegistry).forEach(entry => {
    if (!seen.has(entry.domain)) {
      seen.set(entry.domain, { domain: entry.domain, displayName: entry.domainDisplayName })
    }
  })
  return Array.from(seen.values())
}
